import platform from './Platform/index';
import s3 from './S3/index';

const drivers = {
  Platform: platform,
  S3: s3
};

export default drivers;
